module.exports = __webpack_public_path__ + "img/134.efab6053.jpg";